// when this behavior is added to the form object, heights will be
// synced with the form object
define('formkit/behavior/sync.form.object.heights.behavior',['require','exports','module','underscore','marionette','backbone.radio'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var Radio = require('backbone.radio');

  var SyncFormObjectHeightsBehavior = Mn.Behavior.extend({

    defaults: {
      channelPrefix: 'SyncFormObjectHeightBehavior'
    },

    onFirstRender: function() {
      var templateObjectModel = this.view.model;
      var stream = templateObjectModel.get('stream');

      var channelName = this.getOption('channelPrefix') + '_' + (stream? stream.id: templateObjectModel.id);

      // check if the other view already exists on the radio channel
      var otherTemplateObjectView = Radio.request(channelName, 'view');
      if (otherTemplateObjectView) {
        this.syncHeightWith(otherTemplateObjectView);
      }
      else {
        Radio.replyOnce(channelName, 'view', this.view);
      }
    },

    syncHeightWith: function(otherTemplateObjectView) {
      var view = this.view;
      var self = this;

      // debounce, so that function is only called once per couple of form objects
      var updateHeight = _.debounce(function() {
        self.setHeights(view, otherTemplateObjectView, '');

        var maxHeight = Math.max(view.$el.outerHeight(), otherTemplateObjectView.$el.outerHeight())

        if (self.isViewVisible(view)) {
          self.setHeights(view, otherTemplateObjectView, maxHeight + 'px');
        }
        else {
          self.onChangeVisible(view, updateHeight);
        }
      });

      // watch for both views to finish rendering and calculating height
      this.onMutationOf(view.el, updateHeight);
      this.onMutationOf(otherTemplateObjectView.el, updateHeight);
    },

    onMutationOf: function(el, callback) {
      var observer = new MutationObserver(function(mutations) {
        callback();
      });
      observer.observe(el, {
        childList : true,
        subtree   : true
      });
    },

    setHeights: function(view1, view2, height) {
      view1.$el.css('height', height);
      view2.$el.css('height', height);
    },

    isViewVisible: function(view) {
      if (!view) {
        view = this.view;
      }
      return view.$el.is(':visible');
    },

    onChangeVisible: function(view, callback) {
      var self = this;
      var timeInterval = 200;

      var interval = setInterval(function () {
        if(!view || view.isDestroyed) {
          clearInterval(interval);
        } else if (self.isViewVisible(view)) {
          callback();
          clearInterval(interval);
        }
      }, timeInterval);

      self.on('destroy', function() {
        clearInterval(interval);
      });
    }

  });
  module.exports = SyncFormObjectHeightsBehavior;
});

